import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getDashboardStats } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';

/**
 * Custom hook to fetch and manage dashboard statistics with caching
 */
export const useDashboardStats = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const { data: stats, isLoading: loading, error } = useQuery({
    queryKey: ['dashboardStats', user?.id],
    queryFn: async () => {
      if (!user) return null;
      return await getDashboardStats(user.id);
    },
    enabled: !!user, // Only fetch if user is logged in
    placeholderData: {
      total_uploads: 0,
      completed_documents: 0,
      processing_documents: 0,
      failed_documents: 0,
      today_uploads: 0,
      remaining_uploads: 0,
      is_premium: false,
      member_since: null,
    },
    staleTime: 1000 * 60 * 2, // Consider data fresh for 2 minutes
  });

  const refreshStats = () => {
    if (user) {
      queryClient.invalidateQueries({ queryKey: ['dashboardStats', user.id] });
    }
  };

  return { 
    stats, 
    loading: loading && !stats, // Keeps displaying cached stats while refreshing in background
    error: error ? error.message : null, 
    refreshStats 
  };
};

export default useDashboardStats;